module.exports = new __parcel__URL__("trust.610f9b95.svg").toString();